import React, { useMemo } from 'react'
import { BiSolidMessage } from 'react-icons/bi'
import { referralVariants } from '@web/modules/core'
import { SOURCE_TYPES } from '@repo/core'

interface ReferralHeaderProps {
  sourceType: string
}

const { header } = referralVariants()

const ReferralHeader = ({ sourceType }: ReferralHeaderProps) => {
  const text = useMemo(() => {
    return SOURCE_TYPES[sourceType].description
  }, [sourceType])

  return (
    <div className={header()}>
      {text ? (
        <>
          <BiSolidMessage />
          <p>{text}</p>
        </>
      ) : (
        <></>
      )}
    </div>
  )
}

export default ReferralHeader
